import { FileStoreService } from './../../shared/_services/file-store.service';
import { ApiRestService } from './../../task/_service/api-rest.service';
import { Ruolo } from './../models/Ruolo';
import { Subscription } from 'rxjs';
import { PersonaleStoreService } from './../_service/personale-store.service';
import { Component, OnInit, Input } from '@angular/core';
import { Persona } from '../models/persona';
import { AuthenticationService } from 'src/app/Login/_services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-profilo',
  templateUrl: './profilo.component.html',
  styleUrls: ['./profilo.component.css']
})
export class ProfiloComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  selectedUser: Persona = new Persona();
  constructor(
    private personaleStore: PersonaleStoreService,
    private filestore: FileStoreService,
    private authSvc: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}
  ngOnInit() {
    this.subscriptions.add(this.authSvc.currentUser.subscribe((items) => {
      this.selectedUser = items;
      this.personaleStore.updateSelectedUserWhenProfile(this.selectedUser);
    }));
    this.subscriptions.add(this.personaleStore.$selectedUser.subscribe((item) => {
      if (item)
        this.filestore.SetListaFile(item.files)
    }));
  }
  cancelClick() {
    this.router.navigate([this.route.snapshot.queryParams[' / '] ||'/',])
  }
  saveClick(data: Persona) {
    this.personaleStore.updateProfilo(data);
    if(data.close)
    this.cancelClick();
  }
  deleteClick() {
    this.personaleStore.deleteUser(this.selectedUser);
    this.cancelClick();
  }
  onFileChanged() {
    console.log("file saved")
    this.personaleStore.updateSelectedUserWhenProfile(this.selectedUser);
  }
}
